<template>
  <div
    class="tiss-field mx-1"
    :style="{ width: largura, height: altura }"
    style="
    border-style: solid;
    border-width: 1px;
    -webkit-print-color-adjust: exact;"
  >
    <div class="ml-1 font-weight-bold" style="font-size: 7pt;">
      <span v-html="tabela"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    largura: {
      type: String,
      default: "7cm"
    },
    altura: {
      type: String,
      default: "1.1cm"
    },
    campos: {
      type: Array
    },
    camposL2: {
      type: Array
    },
    numeracao: {
      type: Number
    },
    numeracaoL2: {
      type: Number
    },
    sizeCampos: {
      type: Array,
      default: null
    },
    sizeCamposL2: {
      type: Array,
      default: null
    },
    indice: {
      type: Boolean,
      default: false
    },
    headerLinha2: {
      type: String,
      default: ""
    }
  },
  computed: {
    tabela() {
      let tabelaHTML = "<table><thead><tr>";
      let linhasHTML = "<tbody><tr>";
      let num = this.numeracao;
      // let size = this.largura.match(/\d+/g).map(Number);
      //let unidadeWidth = 2.2;
      let unidadeRelativa;
      let id = 0;
      let size;
      const somatorio = (acc, atual) => acc + atual;

      unidadeRelativa = this.sizeCampos.reduce(somatorio, 0);
      if (this.indice) {
        unidadeRelativa++;
      }
      unidadeRelativa =
        Number(this.largura.match(/\d+/g).map(Number)) / unidadeRelativa;

      if (!this.sizeCampos) {
        size = [];
        let qtdCampos = Object.keys(this.campos).length;
        for (let i = 0; i < qtdCampos; i++) {
          size[i] = 4;
        }
      } else {
        size = this.sizeCampos;
      }

      if (this.indice) {
        tabelaHTML +=
          "<th style='padding-right:1mm; font-size: 5pt; width:1cm;'> </th>";
      }
      if ( this.campos ) { 
        for (let i = 0; i < this.campos.length; i++) {
          let linhaTmp = "<tr style='line-height: 0.25cm'>";
          if (this.indice) {
            linhaTmp +=
              "<td style='padding-left:2mm; font-size:8pt;'>" + (i + 1) + "</td>";
          }
          for (var campo in this.campos[i]) {
            if (i == 0) {
              tabelaHTML +=
                "<th class='font-weight-bold' style='padding-right:2mm; font-size: 5pt; width:" +
                unidadeRelativa * (size[id] ? size[id] : 2) +
                "cm; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;'>" +
                (num + id) +
                "-" +
                campo +
                "</th>";
            }

            //let addStyle =  size[id] > 10 ? "max-width: 250px;" : "";

            linhaTmp +=
              "<td class='font-weight-normal' style='padding-left:2mm; font-size:8pt; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; max-width: 330px;'" +
              "<span style='overflow: hidden; white-space: nowrap; text-overflow: ellipsis;'>" +
              this.campos[i][campo] +
              "</span></td>";
            id++;
          }
          linhaTmp += "</tr>";
          linhasHTML += linhaTmp;

          // Segunda linha da tabela
          if (this.camposL2 && this.camposL2.length > 0) {
            linhasHTML += this.buildLinha2(i);
          }
        }
      }
      linhasHTML += "</tbody>";
      tabelaHTML +=
        "</tr>" + this.buildHeaderLinha2() + "</thead>" + linhasHTML;
      tabelaHTML += "</table>";
      return tabelaHTML;
    }
  },
  methods: {
    buildLinha2(index) {
      let num = this.numeracaoL2;
      let id = 0;
      let size;
      let linhaTmp = "<tr>";

      if (!this.sizeCamposL2) {
        size = [];
        let qtdCampos = Object.keys(this.camposL2).length;
        for (let i = 0; i < qtdCampos; i++) {
          size[i] = 4;
        }
      } else {
        size = this.sizeCamposL2;
      }

      linhaTmp += "<td style='padding-left:2mm; font-size:8pt;'></td>";

      for (var campo in this.camposL2[index]) {
        let addclass = size[id] > 10 ? "text-truncated text-nowrap" : "";

        linhaTmp +=
          "<td class='font-weight-normal" +
          addclass +
          "' style='padding-left:2mm; font-size:8pt; '>" +
          (num + id) +
          "-" +
          this.camposL2[index][campo] +
          "</td>";
        id++;
      }
      linhaTmp += "</tr>";
      return linhaTmp;
    },
    buildHeaderLinha2() {
      // Código especifico para linha 2 na guia de outras despesas
      if (this.headerLinha2) {
        let qtdCampos = this.sizeCampos.length;
        var linha2 =
          "<td colspan='" +
          qtdCampos +
          "' class='font-weight-bold' style='padding-right:2mm; font-size: 5pt; text-align: center;'>" +
          this.headerLinha2 +
          "</th>";
        return "<tr>" + linha2 + "</tr>";
      } else return "";
    }
  }
};
</script>

<style></style>
